import { faUser } from '@fortawesome/pro-light-svg-icons';
import { faGears, faUserGroup } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { AddAppUserForm } from '~/components/forms/AppUserForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppAddUserPageProps = {
  appId: string;
};

export const AppAddUserPage: React.FC<IAppAddUserPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const parentUrl = `/apps/${appId}/settings/users`;

  return (
    <>
      <Helmet>
        <title>{t('AppAddUserPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={`/apps/${appId}/settings`}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faUserGroup} />
          {t('common.appUsers')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faUser} />}
        title={t('AppAddUserPage.title')}
        subtitle={t('AppAddUserPage.subtitle')}
        previousUrl={parentUrl}
      />

      <AddAppUserForm
        first
        appId={appId}
        onSuccess={() => navigate(parentUrl)}
        cancelUrl={parentUrl}
      />
    </>
  );
};
